var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinktreeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.78947 12.1597H9.38314L4.71184 7.7063C4.39368 7.40315 4.38421 6.89946 4.69052 6.58446L6.47315 4.7521C6.78341 4.43315 7.29499 4.43315 7.60525 4.7521L12.0429 9.31446V2.78947C12.0429 2.35368 12.3966 2 12.8323 2H15.5923C16.0281 2 16.3818 2.35368 16.3818 2.78947V9.31367L20.8202 4.76078C21.1297 4.44342 21.6405 4.44263 21.9508 4.76078L23.7294 6.58367C24.0365 6.89867 24.0271 7.40394 23.7089 7.70709L19.0415 12.1479H25.6328C26.0686 12.1479 26.4223 12.5016 26.4223 12.9373V15.4873C26.4223 15.9231 26.0686 16.2768 25.6328 16.2768H18.9989L23.7081 20.8526C24.0231 21.1589 24.0278 21.6634 23.7184 21.9752L21.9452 23.7618C21.6365 24.0728 21.1344 24.0729 20.8258 23.7626L14.2131 17.1168L7.59815 23.7642C7.29025 24.0736 6.78894 24.0744 6.48025 23.7657L4.70157 21.9871C4.38973 21.6752 4.39368 21.1692 4.70947 20.8629L9.41867 16.2887H2.78947C2.35368 16.2887 2 15.935 2 15.4992V12.9492C2 12.5126 2.35289 12.1597 2.78947 12.1597Z",
    fill: "#006CEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8197 22.2019H15.5797C16.0155 22.2019 16.3692 22.5556 16.3692 22.9914V31.2106C16.3692 31.6464 16.0155 32 15.5797 32H12.8197C12.384 32 12.0303 31.6464 12.0303 31.2106V22.9914C12.0303 22.5556 12.384 22.2019 12.8197 22.2019Z",
    fill: "#006CEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2476 19.1621L14.7713 17.6787C14.4626 17.3685 13.9605 17.3685 13.6518 17.6787L7.59657 23.764C7.28867 24.0734 6.78736 24.0742 6.47868 23.7655L4.69999 21.9869C4.38815 21.675 4.3921 21.169 4.70789 20.8627L8.0213 17.644C8.52972 17.1498 8.17999 16.2885 7.47104 16.2885H2.78947C2.35368 16.2885 2 15.9348 2 15.499V12.949C2 12.5132 2.35368 12.1595 2.78947 12.1595H7.41104C8.12315 12.1595 8.4713 11.2903 7.95578 10.7985L4.71184 7.70611C4.39368 7.40295 4.38421 6.89927 4.69052 6.58427L6.47315 4.75191C6.78341 4.43296 7.29499 4.43296 7.60525 4.75191L10.6881 7.92085C11.1824 8.42848 12.0437 8.07874 12.0437 7.37058V6.78795",
    stroke: "#006CEC",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.042 2.78947C12.042 2.35368 12.3957 2 12.8315 2H15.5915C16.0272 2 16.3809 2.35368 16.3809 2.78947V7.37236C16.3809 8.08051 17.2415 8.43025 17.7357 7.92341L20.8193 4.75999C21.1288 4.44263 21.6396 4.44184 21.9499 4.75999L23.7285 6.58289C24.0357 6.89788 24.0262 7.40315 23.708 7.7063L20.4712 10.786C19.9549 11.2771 20.3022 12.1471 21.0151 12.1471H25.632C26.0678 12.1471 26.4214 12.5008 26.4214 12.9366V15.4866C26.4214 15.9223 26.0678 16.276 25.632 16.276H20.9433C20.2343 16.276 19.8846 17.1373 20.393 17.6315L23.7072 20.8518C24.0222 21.1581 24.027 21.6626 23.7175 21.9744L21.9443 23.761C21.6357 24.0721 21.1336 24.0721 20.8249 23.7618L19.2728 22.2018",
    stroke: "#006CEC",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0303 25.1132V22.9919C12.0303 22.5561 12.384 22.2024 12.8197 22.2024H15.5797C16.0155 22.2024 16.3692 22.5561 16.3692 22.9919V31.2103C16.3692 31.6461 16.0155 31.9997 15.5797 31.9997H12.8197C12.384 31.9997 12.0303 31.6461 12.0303 31.2103V29.5808",
    stroke: "#006CEC",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinktreeLogo);
export default __webpack_public_path__ + "static/media/linktree-logo.993a5b471b86fd0d074f5e50c69215ae.svg";
export { ForwardRef as ReactComponent };